import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueBus from 'vue-bus'
import VueYoutube from 'vue-youtube'
import VueClipboard from 'vue-clipboard2'

// handle layouts
import Admin from './layouts/Admin.vue'
import AdminLogin from './layouts/AdminLogin.vue'
import ClientLogin from './layouts/ClientLogin.vue'
import ClientInverseNav from './layouts/ClientInverseNav.vue'
import Client from './layouts/Client.vue'
import Default from './layouts/Default.vue'

Vue.component('admin-layout', Admin)
Vue.component('admin-login-layout', AdminLogin)
Vue.component('client-layout', Client)
Vue.component('client-inverse-layout', ClientInverseNav)
Vue.component('client-login-layout', ClientLogin)
Vue.component('default-layout', Default)

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(VueBus)
Vue.use(VueYoutube)
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
